/**
 * UploadTrigger
 * 
 * @Author: Focci
 * @Date: 2023-08-16 15:01:36
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-16 15:01:36
 */

'use Client'

import PropTypes from 'prop-types'
import SVGUploadImage from '@img/upload-image.svg'

export function DefaultUploadTrigger() {
  return (
    <div 
      className="
        h-16 w-16 border border-c6c flex items-center 
        justify-center cursor-pointer
      "
    >
      <SVGUploadImage />
    </div>
  )
}

export default function UploadTrigger({
  onChange = () => {},
  inputProps,
  children
}) {
  const handleFileChange = (e) => {
    onChange(e.target.files)
  }

  return (
    <label className="inine-flex">
      <input
        type="file"
        accept="image/*"
        {...inputProps}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      {children || <DefaultUploadTrigger />}
    </label>
  )
}

UploadTrigger.propTypes = {
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
  children: PropTypes.node,
}
